/** @format */

import { Table } from "antd";
import { useCallback, useEffect, useMemo } from "react";
import {
  columnsPencairan,
  isJenjangValid,
  JENJANG_INVALID_MESSAGE,
} from "./Component/ColumnTable";
import { usePencairanBos } from "hooks/HookBos/usePencairanBos";
import notifAlert from "components/NotifAlert";

type contentPenyaluranType = {
  auth: any;
  route: any;
  dataState: any;
};
export const ContentPenyaluran = ({
  auth,
  route,
  dataState,
}: contentPenyaluranType) => {
  const {
    loading,
    penyaluranSumberDanaBos,
    getDataPenyaluran,
    deleteDataPencairan,
  } = usePencairanBos(auth);

  useEffect(() => {
    if (auth?.isTahun) {
      getDataPenyaluran();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth?.isTahun]);

  const handleDelete = useCallback(
    async (values: any) => {
      if (!isJenjangValid(values?.jenjang)) {
        notifAlert({ type: "warning", description: JENJANG_INVALID_MESSAGE });
        return;
      }
      const payload = {
        tahun: parseInt(auth?.isTahun),
        tahap: parseInt(values?.tahapan),
        batch: parseInt(values?.batch),
        status: 3,
        jenjang: values?.jenjang,
      };
      const res = await deleteDataPencairan(payload, "penyaluran");
      if (res) {
        notifAlert({
          type: "success",
          description: "Penghapusan Data Madrasah Berhasil",
        });
      }
    },
    [auth?.isTahun, deleteDataPencairan],
  );

  const columns = useMemo(() => {
    return columnsPencairan(route, dataState, handleDelete);
  }, [dataState, handleDelete, route]);

  return (
    <>
      <Table
        rowKey={(record) =>
          `re-${record?.batch}-${record?.tahapan}-${record?.jenjang}`
        }
        loading={loading}
        columns={columns}
        dataSource={penyaluranSumberDanaBos}
        bordered
      />
    </>
  );
};
